import { useEffect, useState } from "react";
import { getRandomArbitrary } from "@features/pulse/utils/helpers";
import { useIsFirstMount } from "@hooks/useIsFirstMount";

/**
 * Custom hook to get a random number between 0 and 11.
 * This is used to randomize the the end card text in the Pulse feature.
 */
export const useGetRandomArbitrary = () => {
  const [randomNumber, setRandomNumber] = useState(-1);
  const isFirstMount = useIsFirstMount();

  useEffect(() => {
    if (!isFirstMount) return;
    if (randomNumber !== -1) return;

    const randomNum = getRandomArbitrary(0, 11);

    setRandomNumber(randomNum);
  }, [isFirstMount, randomNumber]);

  return { randomNumber };
};
